import { X, MessageCircle } from "lucide-react";
import { useState } from "react";

export default function SaleBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="relative z-[60] bg-primary text-primary-foreground overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute -top-1/2 -right-1/4 w-96 h-96 rounded-full bg-white/20 blur-3xl" />
        <div className="absolute -bottom-1/2 -left-1/4 w-72 h-72 rounded-full bg-white/10 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-2.5">
        <div className="flex items-center justify-center gap-2 text-center">
          <a
            href="https://wa.me/34661404992?text=Hola,%20estoy%20interesado%20en%20el%20prototipo%20web%20funcional%20en%20venta"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm font-medium hover:underline"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">Prototipo web funcional en venta — WhatsApp 661 404 992</span>
            <span className="sm:hidden">Prototipo web en venta: 661 404 992</span>
          </a>
          <button
            onClick={() => setDismissed(true)}
            className="absolute right-2 sm:right-4 p-1 rounded-md hover:bg-white/20 transition-colors"
            aria-label="Cerrar banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
